import { render, staticRenderFns } from "./creationInfo.vue?vue&type=template&id=1d357c5c&scoped=true"
import script from "./creationInfo.vue?vue&type=script&lang=js"
export * from "./creationInfo.vue?vue&type=script&lang=js"
import style0 from "./creationInfo.vue?vue&type=style&index=0&id=1d357c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d357c5c",
  null
  
)

export default component.exports